import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { formatDate, usePathParam } from '@chilecompra/react-kit'
import { Button, Table, TableCell, TableRow } from '@chilecompra/react-kit/components'

import { onCloseQuoteRecordsDialog, onGetPurchaseRecordsThunk } from './QuoteRecordsDialog.actions'
import {
  BodyLink,
  BodyParagraph,
  BodySecondText,
  Dialog,
  GridContainer,
  GridItem,
  Subtitle,
  Title
} from './QuoteRecordsDialog.styles'

import { topPage } from '../../modules/utils/topPage'
import { inIframe } from '../../modules/utils/inIframe'

/**
 * The QuoteRecordsDialog's container.
 */
const QuoteRecordsDialog = () => {
  const dispatch = useDispatch()
  const quoteId = usePathParam('quoteId')

  const { open, records } = useSelector(state => state.quoteRecordsDialog)

  const isInIframe = useMemo(() => inIframe(), [])

  const handleClose = () => dispatch(onCloseQuoteRecordsDialog())

  useEffect(() => {
    topPage(isInIframe, open)

    if (!open || !quoteId) {
      return
    }

    dispatch(onGetPurchaseRecordsThunk({ quoteId }))
  }, [open, quoteId])

  return (
    <Dialog maxWidth="888px" open={open} verticalAlign="top" onClose={handleClose}>
      <GridContainer padding="50px 0 5px">
        <GridItem align="center" xs={12}>
          <Title>Historial Compra Ágil</Title>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 28px">
        <GridItem align="center" xs={12}>
          <Subtitle>{quoteId}</Subtitle>
        </GridItem>
      </GridContainer>
      <GridContainer enableBorder margin="0 0 37px" padding="0 10px">
        <GridItem xs={12}>
          <Table disableLatestBottomBorder height="300px">
            <TableRow enableHead>
              <TableCell>Usuario</TableCell>
              <TableCell>Organismo comprador</TableCell>
              <TableCell>Fecha</TableCell>
              <TableCell>Acción</TableCell>
            </TableRow>
            {records.map(record => (
              <TableRow key={record.id}>
                <TableCell>
                  <BodyParagraph>{record.user}</BodyParagraph>
                </TableCell>
                <TableCell>
                  <BodyParagraph>{record.organization}</BodyParagraph>
                  <BodyParagraph>
                    <BodySecondText>{record.department}</BodySecondText>
                  </BodyParagraph>
                </TableCell>
                <TableCell>
                  {record.createdAt && <BodyParagraph>{formatDate(new Date(record.createdAt))}</BodyParagraph>}
                </TableCell>
                <TableCell>
                  <BodyParagraph>{record.log}</BodyParagraph>
                  {record.link && (
                    <BodyParagraph>
                      <BodyLink href={record.link} target="_blank">
                        Ver orden de compra
                      </BodyLink>
                    </BodyParagraph>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </Table>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 36px">
        <GridItem align="center" xs={12}>
          <Button onClick={handleClose}>Cerrar</Button>
        </GridItem>
      </GridContainer>
    </Dialog>
  )
}

export default QuoteRecordsDialog
